export default __webpack_public_path__ + "static/app-landing-page-2-ab88d23426a0db3f15af58925a6e7cfb.png";